import { SuiNetworks } from '@packages/utils/enums'
import { type TProfileLinks } from '@packages/utils/types'
import { configStore } from '@src/stores/config'
import { get } from 'svelte/store'
import SuiLogo from '@images/sui-logo.png'

export const getProfileLinks = (address: string): TProfileLinks => {
  const { suiNetwork } = get(configStore)
  switch (suiNetwork) {
    case SuiNetworks.DEVNET:
      return {
        scanName: `Sui ${SuiNetworks.DEVNET}`,
        scanIcon: SuiLogo,
        scanLink: 'https://suiscan.xyz/devnet/account/' + address,
      }
    case SuiNetworks.TESTNET:
      return {
        scanName: `Sui ${SuiNetworks.TESTNET}`,
        scanIcon: SuiLogo,
        scanLink: 'https://suiscan.xyz/testnet/account/' + address,
      }
    case SuiNetworks.MAINNET:
    default:
      return {
        scanName: `Sui ${SuiNetworks.MAINNET}`,
        scanIcon: SuiLogo,
        scanLink: 'https://suiscan.xyz/mainnet/account/' + address,
      }
  }
}
